define([
  'react',
  'prop-types',
  'underscore',
  'es6!sumo/util',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Drag',
], (React, PropTypes, _, Util, Drag) => {
  const VALID_SIDES = [
    'top',
    'right',
    'bottom',
    'left',
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right',
  ];

  const classNames = Util.classNames;

  @Drag({ transform: false })
  class ResizeHandle extends React.Component {
    static propTypes = {
      side: PropTypes.string,
    };

    render() {
      let { side, className, style, draggableEventHandlers } = this.props;
      const handleClassName = classNames(
        `sumome-react-wysiwyg-resize-handle-${side}`,
        className,
      );

      if (VALID_SIDES.indexOf(side) < 0) side = 'bottom';

      return (
        <div
          className={handleClassName}
          style={style}
          {...draggableEventHandlers}
        />
      );
    }
  }

  return ResizeHandle;
});
